import React, { createContext, useState, useEffect, useContext } from "react";
import env from "@beam-australia/react-env";
import useApi from "../hooks/useApi";

const LogoContext = createContext();

export const useLogo = () => useContext(LogoContext);

export const LogoProvider = ({ children }) => {
  const api = useApi();
  const [logo, setLogo] = useState(null);

  const clientId = localStorage.getItem("clientId");

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await api.get(`${env("API_URL")}/website/logo`);
        setLogo(response.data);
      } catch (error) {
        console.error("Error fetching logo:", error);
      }
    };

    fetchLogo();
  }, [clientId, api]); // Dependencia para asegurar que el API se obtiene correctamente

  return <LogoContext.Provider value={logo}>{children}</LogoContext.Provider>;
};
